import { useRouter } from 'next/router'
import { parseUrlPathName } from '@corratech/pylot-tag-manager/src/utils/parseUrlPathName'
import { useTrackCheckoutStep } from '../hooks'
import { CheckoutStepNameEnum } from 'config'

export const hasToken = (): boolean => {
    if (typeof window !== 'object') {
        return false
    }
    return !!window.localStorage.getItem('pylot_token')
}

export const CHECKOUT_PAGE_ROUTE = 'checkout'

export const useTrackCustomerCheckout = () => {
    const { asPath } = useRouter()

    const trackCheckoutStep = useTrackCheckoutStep()

    const fireGuestCheckoutGTMEvent = () => {
        trackCheckoutStep({ step: CheckoutStepNameEnum.LOGIN, option: 'guest' })
    }

    const fireSignupCheckoutGTMEvent = () => {
        trackCheckoutStep({
            step: CheckoutStepNameEnum.SIGNUP,
            option: 'email_id'
        })
    }

    const fireLoginCheckoutGTMEvent = () => {
        const pathName = parseUrlPathName(asPath)
        if (pathName.endsWith(CHECKOUT_PAGE_ROUTE) && hasToken()) {
            trackCheckoutStep({
                step: CheckoutStepNameEnum.LOGIN,
                option: 'email'
            })
        }
    }

    return {
        fireGuestCheckoutGTMEvent,
        fireSignupCheckoutGTMEvent,
        fireLoginCheckoutGTMEvent
    }
}
